import { createSelector } from 'reselect';

const getRoot = state => state;
const getState = createSelector(getRoot, state => state.vehicleProperties);
export const isLoadingVehicleProperties = createSelector(getState, ({loading}) => loading);
